const state = {
    comInfo: JSON.parse(sessionStorage.getItem("comInfo")) || {},
    reportStepId: sessionStorage.getItem("annual_reportStepId") || [],
    annualStepStatus: sessionStorage.getItem("annual_annualStepStatus") || 1,
    nowStepStatus: sessionStorage.getItem("annual_nowStepStatus") || 1,
    childStepStatus: sessionStorage.getItem("annual_childStepStatus") || 1
};

const mutations = {
    SET_COM_INFO: (state, comInfo) => {
        state.comInfo = comInfo;
        sessionStorage.setItem("comInfo", JSON.stringify(comInfo));
    },
    SET_REPORT_STEP_ID: (state, reportStepId) => {
        state.reportStepId = reportStepId;
        sessionStorage.setItem("annual_reportStepId", reportStepId);
    },
    SET_ANNUAL_STEP_STATUS: (state, annualStepStatus) => {
        state.annualStepStatus = annualStepStatus;
        sessionStorage.setItem("annual_annualStepStatus", annualStepStatus);
    },
    SET_NOW_STEP_STATUS: (state, nowStepStatus) => {
        state.nowStepStatus = nowStepStatus;
        sessionStorage.setItem("annual_nowStepStatus", nowStepStatus);
    },
    SET_CHILD_STEP_STATUS: (state, childStepStatus) => {
        state.childStepStatus = childStepStatus;
        sessionStorage.setItem("annual_childStepStatus", childStepStatus);
    }
};

const actions = {
    setComInfo({ commit }, comInfo) {
        commit("SET_COM_INFO", comInfo);
    },
    setReportStepId({ commit }, reportStepId) {
        commit("SET_REPORT_STEP_ID", reportStepId);
    },
    setAnnualStepStatus({ commit }, annualStepStatus) {
        commit("SET_ANNUAL_STEP_STATUS", annualStepStatus);
    },
    setNowStepStatus({ commit }, nowStepStatus) {
        commit("SET_NOW_STEP_STATUS", nowStepStatus);
    },
    setChildStepStatus({ commit }, childStepStatus) {
        commit("SET_CHILD_STEP_STATUS", childStepStatus);
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
